import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {} from "@fortawesome/free-regular-svg-icons";
import {
  faReact,
  faJs,
  faNode,
  faHtml5,
  faCss3,
  faGithub,
  faCodepen,
  faBootstrap,
} from "@fortawesome/free-brands-svg-icons";
import React from "react";
import vscodeIcon from "../img/vscode.png";

const Skill = () => {
  return (
    <div className="hero h-auto bg-black">
      <div className="hero-content flex-col ">
        <div className="flex flex-col items-center p-10 ">
          <h1 className="text-white text-5xl mb-10">Skills</h1>
          <div className="flex flex-wrap justify-around lg:space-x-8 space-x-8">
            <FontAwesomeIcon color="#61DBFB" icon={faReact} size="7x" />
            <FontAwesomeIcon color="#f0db4f" icon={faJs} size="7x" />
            <FontAwesomeIcon color="#68a063" icon={faNode} size="7x" />
            <FontAwesomeIcon color="#f06529" icon={faHtml5} size="7x" />
            <FontAwesomeIcon color="#264de4" icon={faCss3} size="7x" />
            <FontAwesomeIcon color="#563d7c" icon={faBootstrap} size="7x" />
            <FontAwesomeIcon color="#9CDAF1" icon={faGithub} size="7x" />
            <FontAwesomeIcon color="#9CDAF1" icon={vscodeIcon} size="7x" />
            <FontAwesomeIcon color="#2965f1" icon={faCodepen} size="7x" />
          </div>
          <div className="w-full text-white mt-20 flex flex-row justify-between text-xl">
            <div className="leading-loose">
              <h1 className="underline">Language</h1>
              <p>Javascript</p>
              <p>HTML5</p>
              <p>CSS3</p>
            </div>

            <div className="leading-loose">
              <h1 className="underline">Framework</h1>
              <p>React.js</p>
              <p>Node.js</p>
            </div>

            <div className="leading-loose">
              <h1 className="underline">Database</h1>
              <p>MongoDB</p>
              <p>Express.js</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skill;
